module.exports = __webpack_public_path__ + "img/ic_network_wifi.527f3e86.svg";